export default __webpack_public_path__ + "static/media/TBM-2.a76de867.jpg";